// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","container_cart":"Header_container_cart__wSjMW","shopping_cart":"Header_shopping_cart__DWAPl"};